import { Font, StyleSheet } from '@react-pdf/renderer';
import { FONT_PATHS } from 'constants/fontPaths';

Font.register({ family: 'Stangith', src: FONT_PATHS.Stangith });

Font.register({
	family: 'Roboto',
	fonts: [
		{ src: FONT_PATHS.RobotoRegular, fontStyle: 'normal', fontWeight: 'normal' },
		{ src: FONT_PATHS.RobotoMedium, fontStyle: 'normal', fontWeight: 'medium' },
		{ src: FONT_PATHS.RobotoBold, fontStyle: 'normal', fontWeight: 'bold' },
	],
});

const Template2Styles = StyleSheet.create({
	document: {},
	page: {
		position: 'relative',
		backgroundColor: '#FBF9EC',
		height: '100%',
		padding: '20px',
	},
	usernameBox: {
		position: 'relative',
		alignSelf: 'flex-start',
	},
	usernameBoxBG: {
		position: 'absolute',
		top: '12px',
		right: '-65px',
		width: '95px',
		height: '45px',
		backgroundColor: '#FBE7E0',
		borderRadius: '50px',
	},
	username: {
		fontSize: '55px',
		color: '#034757',
		lineHeight: 'normal',
		fontWeight: 'bold',
		fontFamily: 'Stangith',
		textTransform: 'capitalize',
		marginBottom: '5px',
	},
	designation: {
		fontSize: '10px',
		color: '#757575',
		lineHeight: 'normal',
		fontWeight: 'bold',
		fontFamily: 'Roboto',
		letterSpacing: '2px',
		textTransform: 'capitalize',
	},
	underlineBox: {
		width: '55px',
		height: '2px',
		backgroundColor: '#FBE7E0',
		marginTop: '15px',
	},
	aboutBox: {
		flexDirection: 'row',
		gap: '30px',
		alignItems: 'center',
		marginVertical: '35px',
	},
	about: {
		flexDirection: 'row',
		alignItems: 'center',
		gap: '30px',
		flex: '1',
	},
	profileBox: {
		position: 'relative',
		width: '132px',
		height: '132px',
	},
	profileBG: {
		position: 'absolute',
		top: '0',
		left: '0',
		width: '100%',
		height: '100%',
	},
	userImg: {
		width: '120px',
		height: '120px',
		borderRadius: '50%',
		margin: '6px',
		objectFit: 'cover',
	},
	profileContent: {
		flex: '1',
	},
	pageInfo: {
		flexDirection: 'row',
		gap: '40px',
		height: '100%',
		width: '100%',
	},
	left: {
		width: '150px',
		flexDirection: 'column',
		gap: '40px',
	},
	right: {
		flex: '1',
		flexDirection: 'column',
		gap: '30px',
	},
	headingBox: {
		backgroundColor: '#FBE7E0',
		padding: '4px 6px',
		marginBottom: '15px',
		alignSelf: 'flex-start',
	},
	heading: {
		fontSize: '8px',
		color: '#034757',
		lineHeight: 'normal',
		fontWeight: 'bold',
		fontFamily: 'Roboto',
		letterSpacing: '1.7px',
		textTransform: 'uppercase',
	},
	mainBox: {},
	mainBoxInner: {
		flexDirection: 'column',
		gap: '12px',
	},
	detailBoxContent: {
		flexDirection: 'column',
		gap: '5px',
	},
	detailBox: {
		flexDirection: 'row',
		alignItems: 'center',
		width: '100%',
		gap: '8px',
	},
	detailIcon: {
		width: '20px',
		height: '20px',
		objectFit: 'cover',
		objectPosition: 'center',
		borderRadius: '20px',
	},
	detailText: {
		fontSize: '10px',
		color: '#000',
		lineHeight: 'normal',
		fontWeight: 'medium',
		fontFamily: 'Roboto',
	},
	detailSubText: {
		fontSize: '8px',
		color: '#5C5C5C',
		lineHeight: '1.4',
		fontWeight: 'normal',
		fontFamily: 'Roboto',
	},
	rightDetails: {},
	experienceRow: {
		position: 'relative',
		flexDirection: 'row',
		gap: '10px',
		marginLeft: '5px',
		paddingLeft: '20px',
	},
	listBorder: {
		height: '100%',
		borderLeft: '1px solid #034757',
		position: 'absolute',
		left: '0',
		top: '4px',
	},
	listCircle: {
		position: 'absolute',
		left: '-5.5px',
		top: '0',
		width: '10px',
		height: '10px',
		borderRadius: '10px',
		backgroundColor: '#FBE7E0',
		border: '1px solid #034757',
	},
	experienceContent: {
		flex: '1',
		paddingBottom: '10px',
	},
	experienceDate: {
		fontSize: '8px',
		color: '#5C5C5C',
		lineHeight: 'normal',
		fontWeight: '600',
		fontFamily: 'Roboto',
		textTransform: 'capitalize',
		width: '40px',
	},
	ListData: {
		flexDirection: 'row',
		gap: '5px',
		marginBottom: '5px',
	},
	ListBox: {
		marginTop: '8px',
	},
	Listicon: {
		fontSize: '10px',
		color: '#5C5C5C',
		fontWeight: '600',
	},
	skills: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: '6px',
	},
	skillsBox: {
		padding: '4px 10px',
		border: '1px solid #D9D7CA',
		borderRadius: '20px',
	},
	skillsText: {
		fontSize: '8px',
		color: '#292A36',
		fontWeight: 'normal',
		fontFamily: 'Roboto',
		letterSpacing: '0.16px',
		lineHeight: '1.5',
		textTransform: 'capitalize',
	},
	urlData: {
		fontSize: '8px',
		color: '#034757',
		lineHeight: 'normal',
		fontWeight: 'normal',
		fontFamily: 'Roboto',
		backgroundColor: '#F3F1E4',
		padding: '2px 4px',
		alignSelf: 'flex-start',
	},
	projectContent: {
		position: 'relative',
		paddingLeft: '20px',
	},
	projectContentData: {
		flexDirection: 'column',
		gap: '5px',
		paddingBottom: '15px',
		paddingTop: '3px',
	},
	personalContent: {
		position: 'relative',
		paddingLeft: '15px',
	},
	personalDataTitle: {
		fontSize: '7px',
		color: '#757575',
		lineHeight: 'normal',
		fontWeight: 'normal',
		fontFamily: 'Roboto',
		marginBottom: '2px',
	},
	personalData: {
		fontSize: '8px',
		color: '#034757',
		lineHeight: 'normal',
		fontWeight: 'medium',
		fontFamily: 'Roboto',
		marginBottom: '10px',
	},
	bottomBG: {
		position: 'absolute',
		bottom: '0',
		right: '0',
		width: '100px',
		height: '82px',
	},
	hobbies: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: '10px',
	},
	hobbiesIcon: {
		width: '10px',
		height: 'auto',
	},
});

export default Template2Styles;
